export default function CanvasLoader({ title, message = "This might take a few moments" }) {
    return (
        <div className="space-y-3 px-4 text-center" role="status">
            <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-primary-200 border-t-primary-700" />
            <p className="font-Mulish font-semibold text-secondary">{title}</p>
            {message ? <p className="font-Mulish text-sm text-graphite">{message}</p> : null}
        </div>
    );
}
